export const ZOOM_DEFAULTS = {
    DEFAULT_ZOOMLEVEL: 14,
    SINGLE_MARKER: 15,
    SELECTED_LOCATION: 16,
    INITIAL: 6,
} as const;

export interface Location {
    uid: number;
    locationId: number;
    title: string;
    address: string;
    zip: string;
    place: string;
    country: string;
    countryShort: string;
    longitude: number;
    latitude: number;
    company?: string;
    emailAddress?: string;
    phoneNumber?: string;
    moreInfoUrl?: string;
    /** Absolute URL of the location's detail page, resolved server-side. Empty/absent = no detail button. */
    detailUrl?: string;
    area?: string;
    zoomlevel?: number;
    priority?: number;
    distance?: number;
    visibility?: boolean;
}

export interface I18nStrings {
    topline?: string;
    headline?: string;
    description?: string;
    searchPlaceholder?: string;
    searchLabel?: string;
    filterShow?: string;
    filterHide?: string;
    filterReset?: string;
    radiusLabel?: string;
    companyLabel?: string;
    areaLabel?: string;
    selectPlaceholder?: string;
    selectAll?: string;
    resultsFound?: string;
    noResults?: string;
    loading?: string;
    locationError?: string;
    locationNotSupported?: string;
    locationDenied?: string;
    locationUnavailable?: string;
    locationTimeout?: string;
    myLocation?: string;
    useMyLocation?: string;
    routePlanning?: string;
    searchButton?: string;
    showOnMap?: string;
    details?: string;
    radiusOption10?: string;
    radiusOption25?: string;
    radiusOption50?: string;
    radiusOption100?: string;
    radiusOption150?: string;
    listView?: string;
    mapView?: string;
    phoneLabel?: string;
    googleMapsError?: string;
    overlayText?: string;
    overlayLabel?: string;
}

export interface LocationFinderProps {
    apiEndpoint: string;
    /** Selectable radii in km, from plugin.tx_tnlocationfinder.settings.searchRadiusOptions. */
    searchRadiusOptions?: number[];
    /**
     * Scopes DOM ids and element lookups to this instance so several plugins can share one page.
     * TYPO3 passes the content element uid; without it React's useId() supplies a unique value.
     */
    instanceId?: string;
    listAndFilterBelow?: boolean;
    preselectedCompany?: string;
    preselectedArea?: string;
    defaultRadius?: string;
    enableAreaFilter?: boolean;
    defaultCenterLat?: number;
    defaultCenterLng?: number;
    limitNearestLocations?: number;
    className?: string;
    topline?: string;
    headline?: string;
    description?: string;
    i18n?: I18nStrings;
    googleMapsApiKey?: string;
    useZoomlevel?: boolean;
    usePrioritySort?: boolean;
    zoomSingleMarker?: number;
    zoomSelectedLocation?: number;
    zoomInitial?: number;
}

export interface LocationCardProps {
    location: Location;
    isLast?: boolean;
    isSelected?: boolean;
    // Takes the location so callers can pass a stable useCallback instead of a fresh closure per
    // render, which would defeat the React.memo around LocationCard.
    onShowOnMap?: (location: Location) => void;
    showOnMapText?: string;
    detailsText?: string;
    phoneLabel?: string;
}
